module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-md-10"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputName",
      "placeholder": "Order Name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('span', {
    staticClass: "label label-success pull-right"
  }, [_vm._v(_vm._s(_vm.formData.status))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("General Info")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_ITEMS
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabItems()
      }
    }
  }, [_vm._v("Items")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_PAYMENT
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabPayment()
      }
    }
  }, [_vm._v("Payment Info")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    },
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticClass: "box no-border form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputOpeningBalance"
    }
  }, [_vm._v("Document Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.documentDate),
      expression: "formData.documentDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputOpeningBalance",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.documentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "documentDate", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCustomer"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.customerName),
      expression: "formData.customerName"
    }],
    ref: "customerName",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputCustomer",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "customerName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputProject"
    }
  }, [_vm._v("Project")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.projectName),
      expression: "formData.projectName"
    }],
    ref: "projectName",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputProject",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.projectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "projectName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputTotalAmount"
    }
  }, [_vm._v("Total Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.totalAmount),
      expression: "formData.totalAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputTotalAmount",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.totalAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "totalAmount", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputSession"
    }
  }, [_vm._v("Session")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.sessionName),
      expression: "formData.sessionName"
    }],
    ref: "sessionName",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputSession",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.sessionName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "sessionName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputTaxAmount"
    }
  }, [_vm._v("Tax Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.taxAmount),
      expression: "formData.taxAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputTaxAmount",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.taxAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "taxAmount", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputPOS"
    }
  }, [_vm._v("Point of Sales")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.pointOfSalesName),
      expression: "formData.pointOfSalesName"
    }],
    ref: "pointOfSalesName",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputPOS",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.pointOfSalesName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "pointOfSalesName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputNetAmount"
    }
  }, [_vm._v("Net Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.totalAmountIncludeTax),
      expression: "formData.totalAmountIncludeTax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputNetAmount",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.totalAmountIncludeTax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "totalAmountIncludeTax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputPaidAmount"
    }
  }, [_vm._v("Paid Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.paidAmount),
      expression: "formData.paidAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputPaidAmount",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.paidAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "paidAmount", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputReturnAmount"
    }
  }, [_vm._v("Return Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.returnAmount),
      expression: "formData.returnAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputReturnAmount",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.returnAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "returnAmount", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_ITEMS
    },
    attrs: {
      "id": "tab_2"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "col-sm-1 col-md-1 col-lg-1",
    staticStyle: {
      "margin-top": "10px",
      "text-align": "left"
    },
    attrs: {
      "for": "recordPerPageItem"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-md-2 col-lg-1",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('select', {
    ref: "recordPerPageItem",
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.changePageSizeItem($event)
      }
    }
  }, [(_vm.inquiryItemParam.pageSize == 5) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("5")]) : _c('option', [_vm._v("5")]), _vm._v(" "), (_vm.inquiryItemParam.pageSize == 10) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("10")]) : _c('option', [_vm._v("10")]), _vm._v(" "), (_vm.inquiryItemParam.pageSize == 20) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("20")]) : _c('option', [_vm._v("20")]), _vm._v(" "), (_vm.inquiryItemParam.pageSize == 50) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("50")]) : _c('option', [_vm._v("50")]), _vm._v(" "), (_vm.inquiryItemParam.pageSize == 100) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("100")]) : _c('option', [_vm._v("100")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.inquiryItem
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.listItem), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticStyle: {
        "width": "30px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequenceItem + i + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "85px",
        "text-align": "center"
      }
    }, [_c('a', {
      ref: "displayRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplayItem(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-search",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display Item"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(row.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.price))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.discount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.tax))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.taxAmount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.amountIncludeTax))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.currencyName))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.orderId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.productId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.billPlanId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.billPlanSeqNo))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.currenctId))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-rewind",
    on: {
      "click": function($event) {
        _vm.changePageItem(1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-left-b",
    on: {
      "click": function($event) {
        _vm.changePageItem(_vm.inquiryItemParam.CurrentPageNumber - 1)
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("\n                              Page\n                          ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inquiryItemParam.CurrentPageNumber),
      expression: "inquiryItemParam.CurrentPageNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "margin-left": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "id": "CurrentPage"
    },
    domProps: {
      "value": (_vm.inquiryItemParam.CurrentPageNumber)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.gotoPageItem($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inquiryItemParam, "CurrentPageNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "TotalPageText"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.totalPagesItem) + "                \n                          ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-right-b",
    on: {
      "click": function($event) {
        _vm.changePageItem(_vm.inquiryItemParam.CurrentPageNumber + 1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-fastforward",
    on: {
      "click": function($event) {
        _vm.changePageItem(_vm.totalPagesItem)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_ITEMS
    },
    attrs: {
      "id": "tab_3"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "col-sm-1 col-md-1 col-lg-1",
    staticStyle: {
      "margin-top": "10px",
      "text-align": "left"
    },
    attrs: {
      "for": "recordPerPageItem"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-md-2 col-lg-1",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('select', {
    ref: "recordPerPagePayment",
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.changePageSizePayment($event)
      }
    }
  }, [(_vm.inquiryItemParam.pageSize == 5) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("5")]) : _c('option', [_vm._v("5")]), _vm._v(" "), (_vm.inquiryItemParam.pageSize == 10) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("10")]) : _c('option', [_vm._v("10")]), _vm._v(" "), (_vm.inquiryItemParam.pageSize == 20) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("20")]) : _c('option', [_vm._v("20")]), _vm._v(" "), (_vm.inquiryItemParam.pageSize == 50) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("50")]) : _c('option', [_vm._v("50")]), _vm._v(" "), (_vm.inquiryItemParam.pageSize == 100) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("100")]) : _c('option', [_vm._v("100")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.inquiryPayment
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.listPayment), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticStyle: {
        "width": "30px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequenceItem + i + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(row.paymentMethodName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.cardNo))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.currencyName))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.orderId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.sessionId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.pointOfSalesId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.paymentMethodId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.currencyId))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-rewind",
    on: {
      "click": function($event) {
        _vm.changePagePayment(1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-left-b",
    on: {
      "click": function($event) {
        _vm.changePagePayment(_vm.inquiryPaymentParam.CurrentPageNumber - 1)
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("\n                              Page\n                          ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inquiryPaymentParam.CurrentPageNumber),
      expression: "inquiryPaymentParam.CurrentPageNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "margin-left": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "id": "CurrentPage"
    },
    domProps: {
      "value": (_vm.inquiryPaymentParam.CurrentPageNumber)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.gotoPagePayment($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inquiryPaymentParam, "CurrentPageNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "TotalPageText"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.totalPagesPayment) + "                \n                          ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-right-b",
    on: {
      "click": function($event) {
        _vm.changePagePayment(_vm.inquiryPaymentParam.CurrentPageNumber + 1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-fastforward",
    on: {
      "click": function($event) {
        _vm.changePagePayment(_vm.totalPagesPayment)
      }
    }
  })])])])])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.id),
      expression: "formData.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formData.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.projectId),
      expression: "formData.projectId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formData.projectId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "projectId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.customerId),
      expression: "formData.customerId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formData.customerId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "customerId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.pointOfSalesId),
      expression: "formData.pointOfSalesId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formData.pointOfSalesId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "pointOfSalesId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.sessionId),
      expression: "formData.sessionId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formData.sessionId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "sessionId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBack()
      }
    }
  }, [_vm._v("Back")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "85px",
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Tax")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Tax Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Net Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Currency")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Payment Method")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Card No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Currency")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-776bbab4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/POSOrderForm.vue
// module id = 757
// module chunks = 1